import React from "react";
import { useAddCustomColumnModal } from "../../utils/useAddCustomColumnModal";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { ArrowBack } from "@material-ui/icons";
import { CustomColumnFormFields } from "../../../CustomColumnFormFields/CustomColumnFormFields";
import {
  CUSTOM_COLUMN_FORM_KEYS,
  OLDER_CONTACT_VALUE_OPTIONS,
} from "../../../CustomColumnFormFields/constants/CustomColumnFormField.constants";
import { useFormState } from "react-final-form";
import { is_empty } from "features/Common/utils/common.utils";

export const AddCustomColumnModalBase = ({ handleSubmit, submitting }) => {
  const { isAddCustomColumnModalOpen, closeAddCustomColumnModal } =
    useAddCustomColumnModal();

  const {
    values: {
      [CUSTOM_COLUMN_FORM_KEYS.column_name.key]: columnName,
      [CUSTOM_COLUMN_FORM_KEYS.field_type.key]: fieldType,
      [CUSTOM_COLUMN_FORM_KEYS.default_value.key]: defaultValue,
      [CUSTOM_COLUMN_FORM_KEYS.custom_value.key]: customValue,
      [CUSTOM_COLUMN_FORM_KEYS.older_contacts.key]: olderContactsSelection,
    },
  } = useFormState();

  const isColumnDetailsChecked =
    columnName?.length > 2 && fieldType !== undefined;

  const isColumnSettingsChecked =
    olderContactsSelection !== undefined &&
    (olderContactsSelection === OLDER_CONTACT_VALUE_OPTIONS.CUSTOM.value
      ? !is_empty(customValue)
      : olderContactsSelection === OLDER_CONTACT_VALUE_OPTIONS.DEFAULT.value
      ? !is_empty(defaultValue)
      : true);

  const isCreateEnabled = isColumnDetailsChecked && isColumnSettingsChecked;

  return (
    <ExlyModal
      title={
        <div className="tw-flex tw-items-center">
          <ArrowBack
            className="tw-w-6 tw-h-6 tw-text-[#1c1b1f] tw-mr-2 tw-cursor-pointer"
            onClick={closeAddCustomColumnModal}
          />
          New Column
        </div>
      }
      primaryBtnText="Create"
      onPrimaryBtnClick={handleSubmit}
      primaryBtnProps={{
        loading: submitting,
        disabled: submitting || !isCreateEnabled,
      }}
      open={isAddCustomColumnModalOpen}
      onClose={closeAddCustomColumnModal}
      padded={false}
      modal_props={{
        modalPaperClassName: "tw-w-[555px]",
        secondaryBtnClassName: "tw-text-[#493ab1] tw-min-w-auto",
        footerClassName: "!tw-justify-between",
        keepMounted: true,
      }}
      mobile_modal_props={{
        secondaryAction: {
          label: "Cancel",
          onClick: closeAddCustomColumnModal,
          className: "tw-text-[#493ab1] tw-min-w-auto",
        },
      }}
    >
      <CustomColumnFormFields />
    </ExlyModal>
  );
};
